import React from "react";
import RemakeOrder from "./RemakeOrder";
import NavBar from '../../Layouts/NavBar';
import Footer from '../../Layouts/Footer';
// import RoutesBar from "./Components/RoutesBar";
import "./RemakeOrder.css";

const RemakeOrderRoute = () => {
  return (
    <>
        <div className="OrderPage">
            <div className="OrderPageNavBar">      
                <NavBar/>
            </div>
            <div className="">
                <RemakeOrder/>
            </div>
            <div className="OrderPageFooter">
                <Footer/>
            </div>
        </div>
    </>
  );
};

export default RemakeOrderRoute;